import React from 'react';

import { useField } from 'formik';
import type { AlineInputProps } from 'src/AlineInput';
import { AlineInput } from 'src/AlineInput';

interface FormikAlineInputProps extends AlineInputProps {
  fieldName: string;
  displayErrorText?: boolean;
  forwardedRef?: React.Ref<HTMLInputElement>;
}

/**
 * Note forwardedRef is used intentionally here instead of forwardRef.
 */
export function FormikAlineInput<Value = string>(props: FormikAlineInputProps): JSX.Element {
  // Default space is required for helper text to prevent "jump" when rendering an error if no actual helper text is passed in props.
  const { displayErrorText = true, fieldName, forwardedRef, helperText = ' ', ...rest } = props;
  const [field, meta] = useField<Value>(fieldName);
  const errorString = typeof meta.error === 'string' ? meta.error : undefined;
  const showError = !!meta.error && meta.touched;

  return (
    <AlineInput
      ref={forwardedRef}
      error={showError}
      helperText={showError && displayErrorText ? errorString : helperText}
      {...field}
      {...rest}
    />
  );
}
